module.exports = function(location, party) {
    if(location && location.street)
        return buildFromLocation(location);
    return party;
};

function buildFromLocation(location) {
    var street = `${location.street || ''} ${location.streetNumber || ''}`;
    street = street.trim();

    var postal = `${location.postalCode || ''} ${location.city || ''}`;
    postal = postal.trim();

    if(postal)
        return `${street}, ${postal}`;
    return street;
}
